import {uniq, clone} from 'lodash';

const REQUESTTYPES = ['aggregate', 'filter', 'search', 'all', 'preprocessed'];

export default {
    namespaced: true,

    state: {

        params: {
            query: "",
            page: 1,
            limit: 50,
            sortdir: 'a',
            accountId: null,
            filters: [],
        },

        hiddenColumns: [],
        columns: [],

        request: {
            type: ''
        }
    },

    mutations: {
        setQueryValue(state, value) {
            state.params.query = value;
        },

        setRequestTypeValue(state, value) {
            if (!REQUESTTYPES.includes(value)) {
                console.error('SearchStore: request type invalid:', value);
                return;
            }

            state.request.type = value;
        },

        setParams(state, value) {
            let {query, page, limit, sortdir, filters, accountId} = value;

            state.params = Object.assign(
                state.params, {
                    query,
                    page,
                    limit,
                    sortdir,
                    accountId,
                    filters
                }
            );
        },

        setHiddenColumn(state, payload) {
            let {value, isAdding} = payload;

            if (isAdding) {
                state.hiddenColumns.push(value);
            } else {
                let indx = state.hiddenColumns.findIndex(col => col == value);

                if (indx > -1) {
                    state.hiddenColumns.splice(indx, 1);
                }
            }

            state.hiddenColumns = uniq(state.hiddenColumns);
        },

        setColumns(state, value) {
            state.columns = uniq(value);
        }
    },

    actions: {

        updateQueryValue({state, commit, getters, rootGetters}, value) {
            commit('setQueryValue', value);
        },

        updateRequestType({commit}, value) {
            commit('setRequestTypeValue', value);
        },

        updateCurrentParams({commit}, value) {
            commit('setParams', value);
        },

        addHiddenColumn({commit}, value) {
            commit('setHiddenColumn', {value, isAdding: true})
        },

        removeHiddenColumn({commit}, value) {
            commit('setHiddenColumn', {value, isAdding: false})
        },

        updateColumns({commit}, value) {
            commit('setColumns', value);
        },

        /**
         * Reorder main columns array by given column Objects array
         *
         * @param columnObjects - [{id, ...}]
         */
        reorderColumns({state, commit}, columnObjects) {
            let columns = clone(state.columns);

            columns.sort(
                function (a, b) {
                    return columnObjects.findIndex(ele => ele.id == a) - columnObjects.findIndex(ele => ele.id == b)
                }
            );

            commit('setColumns', columns);
        },

        shiftColumnsIndex({state, commit}, payload) {
            let {oldIndex, newIndex} = payload;
            let columns = clone(state.columns);

            if (columns[oldIndex] === undefined || columns[newIndex] === undefined) {
                return console.error('invalid indexes given for columns shift: ', [oldIndex, newIndex]);
            }

            const element = columns.splice(oldIndex, 1);
            columns.splice(newIndex, 0, element[0]);

            commit('setColumns', columns);
        }
    },

    getters: {

        query: state => {
            return state.params.query;
        },

        requestType: state => {
            return state.request.type;
        },

        datatableParams: state => {
            return state.params;
        },

        hiddenColumns: state => {
            return state.hiddenColumns;
        },

        getColumns: state => {
            return state.columns;
        }
    }
};
